import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    document.querySelectorAll(".flex-layout.hero_gallery-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".swiper.hero-gallery");
        const wrapper = swiperEl?.querySelector(".swiper-wrapper");
        if (!swiperEl || !wrapper) return;

        const slides = [...wrapper.children];
        const minSlides = 8;
        for (let i = 0; slides.length && wrapper.children.length < minSlides; i++) {
            const clone = slides[i % slides.length].cloneNode(true);
            clone.setAttribute("aria-hidden", "true");
            wrapper.appendChild(clone);
        }

        new Swiper(swiperEl, {
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: true,
            centeredSlides: true,
            speed: 8000,
            allowTouchMove: false,
            autoplay: reducedMotion ? false : { delay: 0, disableOnInteraction: false },
        });
    });
});
